import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDq_OFTrp-phtDybweEoGfqsud2XCZdb4E",
    authDomain: "caresync-e153c.firebaseapp.com",
    databaseURL: "https://caresync-e153c-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "caresync-e153c",
    storageBucket: "caresync-e153c.firebasestorage.app",
    messagingSenderId: "252789545719",
    appId: "1:252789545719:web:fb927d21963027816211f2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
